import styled from "styled-components";

export const HeaderWrapper = styled.div`
	align-items: center;
	border-bottom: 1px solid #f5f5f5;
	display: flex;
	justify-content: space-between;
	padding: 0rem 3rem;
	width: 100%;
	height: 90px;
	.header-icon {
		width: 46px;
		cursor: pointer;
	}
	.big-header-icon {
		width: 128px;
		cursor: pointer;
	}
	.header-info {
		display: flex;
		img {
			margin-right: 2rem;
		}
	}
	.header-info h1 {
		color: #121212;
		font-size: 16px;
	}
	.header-exit {
		color: #1332d3;
		cursor: pointer;
		display: flex;
		font-size: 16px;
		font-weight: 500;
		img {
			height: 29.76px;
			margin-left: 1rem;
			width: 26.84px;
		}
	}
	@media only screen and (max-width: 650px) {
		height: 56px;

		.header-info {
			img {
				display: none;
			}
		}

		.header-info h1 {
			color: #545759;
			font-size: 14px;
		}
	}
	@media (max-width: 480px) {
		.header-exit {
			p {
				display: none;
			}
		}
	}
`;
